module.exports = __webpack_public_path__ + "media/images/front/accArwSp-49ddf171dc8d41b9a8de1d665b8f476a.png";